import { translations } from './translations';

// English is the default so we know it's there
const available = ['en', ...Object.keys(translations)];

export function resolveLocale(locale: string) {
  // This will be the language code stripped of culture, for example fr-BE -> fr
  const language = locale.replace(/-.*$/, '');

  if (available.includes(locale)) {
    // check full culture, example: fr-BE
    return locale;
  } else if (available.includes(language)) {
    // check just language, example: fr
    return language;
  } else {
    // default to english...
    return 'en';
  }
}
